export const LEFT_ARROW_CODE = "ArrowLeft";
export const RIGHT_ARROW_CODE = "ArrowRight";